var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowStockbig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 9.04766L6.66634 5.23813M10.9444 3.87337L15.7063 6.59432C15.998 6.76093 16.2404 7.00171 16.409 7.29224C16.5776 7.58276 16.6664 7.91271 16.6663 8.24861V12.7038C16.6664 13.0398 16.5776 13.3697 16.409 13.6602C16.2404 13.9507 15.998 14.1915 15.7063 14.3581L10.9444 17.0791C10.6567 17.2434 10.3311 17.3299 9.99967 17.3299C9.6683 17.3299 9.34265 17.2434 9.05491 17.0791L4.29301 14.3581C4.00134 14.1915 3.75891 13.9507 3.59031 13.6602C3.42172 13.3697 3.33295 13.0398 3.33301 12.7038V8.24861C3.33295 7.91271 3.42172 7.58276 3.59031 7.29224C3.75891 7.00171 4.00134 6.76093 4.29301 6.59432L9.05491 3.87337C9.34265 3.70901 9.6683 3.62256 9.99967 3.62256C10.3311 3.62256 10.6567 3.70901 10.9444 3.87337Z",
    stroke: "#E84141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80957 7.61914L9.09719 10.4668C9.37468 10.6161 9.6849 10.6943 10 10.6943C10.3152 10.6943 10.6254 10.6161 10.9029 10.4668L16.1905 7.61914M10 10.9525V17.143",
    stroke: "#E84141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowStockbig);
export default __webpack_public_path__ + "static/media/lowStockbig.40892d55ef96aba29c4b59bf4adc38ac.svg";
export { ForwardRef as ReactComponent };